import { render } from "./SubtaskForm.vue?vue&type=template&id=84bec724"
import script from "./SubtaskForm.vue?vue&type=script&lang=js"
export * from "./SubtaskForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__